import { combineReducers, SliceCaseReducers } from '@reduxjs/toolkit';
import { getLocalizationList } from './localization.action';
import { createCustomSlice } from '../store.utils';
import { getLocalizationInitialState } from './localization.constants';
import { TLocalizationData } from './localization.types';
import { TAsyncThunkData } from 'store/store.types';

// ---------- LIST ----------
const localization = createCustomSlice<
  TLocalizationData,
  void,
  unknown,
  SliceCaseReducers<TAsyncThunkData<TLocalizationData>>
>(
  'localization/localization',
  getLocalizationList,
  {},
  {},
  getLocalizationInitialState() as TAsyncThunkData<TLocalizationData>
);

export const localizationReducer = combineReducers({
  localization: localization.reducer,
});
